<template>
  <div>
    <div class="modal-wx" v-show="isWeChat()">
      <div class="prompt-box-wx"></div>
    </div>
    <div id="header_container" role="banner" class="branding">
      <div id="header_outer" class="container clearfix">
        <div id="header" role="banner" class="clearfix"><a target="_blank" href="https://zhumu.com/" aria-label="徽标"
                                                           class="imglink _2ji06Vlc"><img src="../assets/ZoomLogo.png" alt="" class="logo"></a>
          <!-- <el-dropdown trigger="click" placement="bottom-start" @visible-change="visibleChange" @command="selectItem">
            <span class="el-dropdown-link">
              {{ selectedLabel }} <i class="el-icon-caret-bottom el-icon--right" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="item.value" :key="item.value" v-for="item in options">
                {{ item.label }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
        </div>
      </div>
    </div>
    <div id="zoom-ui-frame" role="main" tabindex="0" class="_38WwFC_g">
      <div class="_2djRjYUu _2uYcRa7_">
      </div>
      <div class="_1doXW0tM"><!---->
        <div>
          <div class="_13FZYIXU _2lLZo0ll"><h1 v-html="selectedContent"></h1>
            <div role="button" tabindex="0" class="_1FvRrPS6" @click="startMeeting">{{selectStartButton}}</div>
          </div>
          <hr>
          <div>
            <h3 role="presentation">{{ selectDownLoadTip }}
              <a target="_blank" href="https://zhumu.com/download" tabindex="0">{{ selectDownLoad }}</a>
            </h3>
          </div>
          <!-- <div style="margin-top: 30px">
            <h3 role="presentation">{{ selectUseTip }}
              <a download="" tabindex="0">{{ selectBrowserJoin }}</a>
            </h3>
          </div> -->
        </div>
      </div>
      <div class="_2xdHfBZh"><p>{{selectidentify}}</p></div>
    </div>
    <div>
      <div id="footer_container" role="contentinfo">
        <div id="footer"><p>版权所有 ©2006-2026 随锐科技集团股份有限公司 保留所有权利。 </p> <!----></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JoinMeeting',
  data() {
    return {
      meetingId:'',
      password:'',
      selectedOption: '2',
      options: [
        { value: '1', label: 'English', content:'Your meeting has been launched.<br> Don\'t see your Zhumu meeting?', startButton:'Launch Meetina', downLoadTip:'Don\'t have Zhumu Client installed?', downLoad:'Download Now', userTip:'Having issues with Zhumu Client?', browserJoin:'Join from Your Browser', identify:'To identify you, phone number verification will be required when you join meetings.' },
        { value: '2', label: '简体中文', content:'你的会议已启动。<br> 没有看到你的瞩目会议？', startButton:'启动会议', downLoadTip:'尚末安装瞩目客户端？', downLoad:'立即下载', userTip:'瞩目客户端出现问题？', browserJoin:'使用浏览器加入', identify:'为了确认身份，你需要在加入会议时进行电话号码验证。'},
        { value: '3', label: '繁体中文', content:'您的會議已經啟動。<br> 找不到您的矚目會議？', startButton:'啟動會議', downLoadTip:'尚未安裝矚目用戶端？', downLoad:'立即下載', userTip:'使用矚目用戶端時發生問題？', browserJoin:'使用浏览器加入', identify:'為識別您的身分，在您加入會議期間需要進行電話號碼驗證。'},
      ],
      domain:''
    };
  },
  computed: {
    selectedLabel() {
      return this.options.find(option => option.value === this.selectedOption)?.label || '';
    },
    selectedContent() {
      return this.options.find(option => option.value === this.selectedOption)?.content || '';
    },
    selectStartButton() {
      return this.options.find(option => option.value === this.selectedOption)?.startButton || '';
    },
    selectDownLoadTip() {
      return this.options.find(option => option.value === this.selectedOption)?.downLoadTip || '';
    },
    selectDownLoad() {
      return this.options.find(option => option.value === this.selectedOption)?.downLoad || '';
    },
    selectUseTip() {
      return this.options.find(option => option.value === this.selectedOption)?.userTip || '';
    },
    selectBrowserJoin() {
      return this.options.find(option => option.value === this.selectedOption)?.browserJoin || '';
    },
    selectidentify() {
      return this.options.find(option => option.value === this.selectedOption)?.identify || '';
    }

  },
  mounted() {
    this.fontSize()
    this.parseUrlParams()
    const currentUrl = window.location.href;
    this.domain = new URL(currentUrl).hostname;
    this.delayFunction(1000, () => {
      this.startMeeting();
    });
  },
  methods: {
    isWeChat () {
      var ua = navigator.userAgent.toLowerCase()
      // eslint-disable-next-line
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true
      } else {
        return false
      }
    },

    isWindowPlat () {
      return navigator.platform.indexOf('Win') > -1
    },
    delayFunction(ms, callback) {
      this.timer = setTimeout(callback, ms);
    },
    selectItem(value) {
      this.selectedOption = value;
    },
    visibleChange(visible) {
      console.log(visible)
      const that = this;
      this.$nextTick(() => {
        that.$nextTick(() => {
          // 获取所有具有 .el-dropdown-menu .el-popper 类的元素
          let elements = document.querySelectorAll('.el-dropdown-menu');
          // 遍历这些元素并修改它们的样式
          for (const element of elements) {
            element.style.left = '1535px';
            element.style.top = '58px';
            element.style.width = '120px';
          }
        })
      })
    },
    parseUrlParams() {
      const urlParams = new URLSearchParams(window.location.search);
      // 提取 j/ 后面的数字作为会议号
      const match = window.location.pathname.match(/\/j\/(\d+)/);
      if (match && match[1]) {
        this.meetingId = match[1];
      }
      // 提取 pwd= 后面的值作为密码
      this.password = urlParams.get('pwd')==undefined?'':urlParams.get('pwd');
    },
    startMeeting(){
      let herf = 'zhumu://' + this.domain + '/join?action=join&confno=' + this.meetingId
      if (this.password!=undefined&&this.password!=''){
        herf += '&pwd=' + this.password
      }
      //console.log(herf)
      window.location.href = herf
    },
    fontSize() {
      let winWidth;
      let winHeight;

      if (window.innerWidth) {
        winWidth = window.innerWidth;
      } else if (document.body && document.body.clientWidth) {
        winWidth = document.body.clientWidth;
      }

      if (window.innerHeight) {
        winHeight = window.innerHeight;
      } else if (document.body && document.body.clientHeight) {
        winHeight = document.body.clientHeight;
      }

      if (document.documentElement && document.documentElement.clientHeight && document.documentElement.clientWidth) {
        winWidth = document.documentElement.clientWidth;
        winHeight = document.documentElement.clientHeight;
      }

      if (
          window.navigator.userAgent.indexOf('Android') !== -1 ||
          window.navigator.userAgent.indexOf('iPhone') !== -1 ||
          window.navigator.userAgent.indexOf('iPod') !== -1
      ) {
        document.getElementsByTagName('html')[0].style.fontSize = Math.min(winWidth, winHeight) / 375 * 100 + 'px';
      } else {
        document.getElementsByTagName('html')[0].style.fontSize = winWidth / 1920 * 100 + 'px';
      }
    }
  }
};
</script>
<style  scoped>
  .el-dropdown{
    cursor: pointer;
    font-size: 12px;
    color: #0e71eb;
    font-weight: 400;
    padding-right: 24px;
    font-family: "Open Sans", "Helvetica", "Arial", sans-serif;
    float: right;
  }
  .el-dropdown :hover {
    text-decoration: underline;
  }
  ::v-deep .el-dropdown-menu__item {
    list-style: none;
    line-height: 35px;
    margin: 0;
    outline: 0;
    padding: 0px 35px 0px 15px;
    color: #232323;
    font-family: "Open Sans", "Helvetica", "Arial", sans-serif;
  }
</style>
<style>
  .PYsMi8aU {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    font-size: 18px;
    line-height: 30px
  }

  .PYsMi8aU b {
    font-weight: 600
  }

  .PYsMi8aU span:first-child {
    font-size: 26px;
    line-height: 32px;
    margin-right: 4px
  }

  .SOTHp0pn {
    background: #ff7800;
    padding-bottom: 20px;
    color: #fff;
    text-align: right
  }

  .SOTHp0pn svg {
    height: 50px;
    width: 50px;
    margin: 8px 8px 0 20px;
    vertical-align: bottom
  }

  .SUrtq2eF {
    color: #333;
    padding: 36px
  }
  ._2djRjYUu {
    height: 35px;
    opacity: 0
  }

  ._2oBl8_qF {
    background: -webkit-gradient(linear, left top, left bottom, from(hsla(0, 0%, 100%, 0)), to(#0e72ed));
    background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #0e72ed)
  }

  ._2oBl8_qF:after {
    height: 100%;
    width: 50%;
    left: 0;
    top: 0;
    background: -webkit-gradient(linear, left bottom, left top, color-stop(10%, hsla(0, 0%, 100%, 0)), color-stop(30%, rgba(14, 113, 235, .5)), to(#0e72ed));
    background: linear-gradient(0deg, hsla(0, 0%, 100%, 0) 10%, rgba(14, 113, 235, .5) 30%, #0e72ed);
    border-radius: 16px 0 0 16px
  }

  ._1wN0sWdc {
    border-radius: 50%;
    width: 26px;
    height: 26px;
    background: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -13px 0 0 -13px;
    z-index: 1
  }

  @-webkit-keyframes _1Bxq11O9 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg)
    }
    to {
      -webkit-transform: rotate(1turn);
      transform: rotate(1turn)
    }
  }

  @keyframes _1Bxq11O9 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg)
    }
    to {
      -webkit-transform: rotate(1turn);
      transform: rotate(1turn)
    }
  }
  ._2avJAE8P {
    opacity: 0
  }

  ._1rffd_G- {
    opacity: 1
  }

  ._1rffd_G-, ._2avJAE8P {
    -webkit-transition: opacity .25s ease-in-out;
    transition: opacity .25s ease-in-out
  }
  ._3bDgIuWu {
    display: inline-block
  }
  ._1FvRrPS6 {
    padding: 8px 40px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-radius: 8px;
    background: #0e72ed;
    text-align: center;
    color: #fff;
    cursor: pointer;
    font-size: 16px;
    line-height: 32px;
    display: inline-block;
    margin-top: 12px
  }

  ._1FvRrPS6 a, a._1FvRrPS6 {
    color: #fff !important;
    text-decoration: none !important
  }

  ._1FvRrPS6:hover {
    background-color: #2681f2
  }

  ._1FvRrPS6:active {
    background-color: #0c63ce
  }

  ._38WwFC_g {
    font-family: Inter, Open Sans, Helvetica, Arial, sans-serif;
    position: relative;
    background: #fff;
    min-height: 480px;
    max-width: 840px;
    margin: 0 auto;
    padding: 130px 60px 48px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-align: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center
  }

  ._38WwFC_g:focus {
    outline: none
  }

  @media (max-width: 500px) {
    ._38WwFC_g {
      padding: 16px;
      -webkit-box-shadow: none;
      box-shadow: none
    }
  }

  ._1doXW0tM {
    font-size: 18px;
    color: #747487;
    width: 100%
  }

  ._1doXW0tM hr {
    margin: 48px 0;
    height: 1px;
    width: 100%;
    border: none;
    background: #ededf4
  }

  ._1doXW0tM h1, ._1doXW0tM h2, ._1doXW0tM h3{
    font-weight: 400;
    margin: 0
  }

  ._1doXW0tM h1 {
    font-size: 20px;
    line-height: 40px;
    padding: 12px 0
  }

  ._1doXW0tM h2 {
    padding: 6px 0
  }

  ._1doXW0tM h2, ._1doXW0tM h3 {
    font-size: 14px;
    line-height: 24px
  }

  ._1doXW0tM h1, ._1doXW0tM h2, ._1doXW0tM h3 {
    color: #232333
  }

  ._1doXW0tM a {
    color: #0e72ed;
    cursor: pointer;
    text-decoration: none
  }

  ._1doXW0tM a, ._1doXW0tM b {
    white-space: nowrap
  }

  @media (max-width: 500px) {
    ._1doXW0tM h1 {
      line-height: 24px
    }
  }

  ._2z_K_TUN {
    line-height: 40px;
    font-size: 16px;
    line-height: 20px;
    padding: 14px 44px
  }

  ._2xdHfBZh {
    margin: 32px auto;
    text-align: center;
    width: 100%;
    color: #747487;
    font-size: 12px;
    font-weight: 300
  }

  ._2xdHfBZh a {
    color: currentColor;
    text-decoration: none
  }

  ._2xdHfBZh a:hover {
    text-decoration: underline
  }

  ._3gyZg9HQ a {
    font-weight: 600
  }

  ._2lLZo0ll {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center
  }

  ._13FZYIXU {
    min-height: 124px
  }

  ._2d6za-vV a {
    display: block
  }

  .AeyZu14Y span {
    color: #fff
  }

  .AeyZu14Y svg {
    height: 16px;
    width: 16px;
    background: #fff;
    padding: 0 1px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    vertical-align: text-bottom;
    margin-right: 2px
  }
  {
    font-family: "Open Sans", "Helvetica", "Arial", sans-serif;
  }
  html, body {
    height: 100%;
    color: #232333;
  }

  body {
    margin: 0;
    padding-top: 64px;
    box-sizing: border-box;
  }

  #header_container {
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 300;
    background-color: rgba(255, 255, 255, .97);
    height: 64px;
    line-height: 64px;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);
  }

  #footer_container {
    padding: 24px;
    width: 100%;
    bottom: 0;
    z-index: 300;
    min-height: 64px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #747487;
    box-sizing: border-box;
  }

  #footer_container a {
    color: #747487;
  }

  #footer_container p {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
  }

  /* Copied from common.css */
  a {
    text-decoration: none;
    color: #0E71EB;
  }

  a:hover {
    text-decoration: underline;
  }

  @media (min-width: 1200px) {
    #header_container .container {
      width: 1200px !important;
    }
  }

  @media (min-width: 1400px) {
    #header_container .container {
      width: 1400px !important;
    }
  }

  #header_outer {
    position: relative;
    font-size: 12px;
    font-weight: 600;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }

  .action-btns {
    float: right;
    padding-right: 24px;
    font-weight: 400;
  }

  /**
   * For branding
   */
  #header .logo {
    height: 35px;
    margin-left: 20px;
    width: auto;
    margin-right: 20px;
    vertical-align: middle;
    box-sizing: border-box;
    border: 0;
  }

  /*  less than 767px  */
  @media screen and (max-width: 767px) {
    #header .logo {
      height: 25px;
    }
  }
  .Vhv6F8ue {
    cursor: pointer;
    position: relative;
    color: #0e71eb
  }

  ._3-Jvciw4, .Vhv6F8ue {
    display: inline-block
  }

  ._3-Jvciw4 {
    width: 0;
    height: 0;
    margin-left: 2px;
    vertical-align: middle;
    border-top: 4px solid;
    border-right: 4px solid transparent;
    border-left: 4px solid transparent
  }

  ._5LZbko-c {
    width: 120px;
    padding: 8px 0;
    position: absolute;
    right: 0;
    border-radius: 4px;
    margin-top: 6px;
    text-shadow: none;
    border: 1px solid #eee;
    background-color: #fff;
    background-clip: padding-box;
    min-width: 100px;
    -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
    box-shadow: 0 6px 12px rgba(0, 0, 0, .175)
  }

  ._5LZbko-c:before {
    position: absolute;
    top: -7px;
    right: 39px;
    display: inline-block !important;
    border-right: 7px solid transparent;
    border-left: 7px solid transparent;
    border-bottom: 7px solid rgba(0, 0, 0, .2);
    content: ""
  }

  ._5LZbko-c:after {
    position: absolute;
    top: -6px;
    right: 40px;
    display: inline-block !important;
    border-right: 6px solid transparent;
    border-bottom: 6px solid #fff;
    border-left: 6px solid transparent;
    content: ""
  }

  ._2Bqw5jgh {
    padding: 10px 20px;
    text-decoration: none;
    line-height: 15px;
    white-space: nowrap;
    text-transform: inherit;
    color: #232323;
    font-size: 14px
  }

  ._2Bqw5jgh:hover {
    background: #f5f5f5
  }

  ._2lmo82iZ {
    background: #f5f5f5
  }

  .Vhv6F8ue li {
    display: block;
    list-style: none
  }
  ._2ji06Vlc {
    font-size: 0;
    vertical-align: middle
  }

/* .modal-wx {
  position: fixed;
  z-index: 1000;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.6);
}
.prompt-box-wx {
  width: 100%;
  height: 100%;
  margin-right: 50px;
  background: url("../assets/wx-icon.png") right no-repeat;
  background-size: 100% 300px;
} */

 .modal-wx {
  z-index:10000;
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
}
.prompt-box-wx {
  width: 76vw;
  height:53vw;
  margin: 1vw 3vw;
  background: url("../assets/wx-icon.png") center no-repeat;
  background-size: 68vw 45vw;
}
</style>